<div class="sub-header-line flex">
  <div class="flex-grow-1 flex flex-row flex-wrap">
    <div class="sub-header">
      <span>Juno's Routes</span>
    </div>
    <div class="flex-grow-1">
      <p-selectButton
        [options]="plannedRouteSearchTypeOptions"
        [(ngModel)]="activeRouteFilterType"
        class="inbox-tabs-select-button"
      >
        <ng-template let-item>
          {{ item.label }}
          <span class="ui-badge">
            <span *ngIf="loadingCounts"><i class="fa fa-spin fa-spinner"></i></span>
            <span *ngIf="!loadingCounts">{{ plannedRouteListCount(item.value) }}</span>
          </span>
        </ng-template>
      </p-selectButton>
      <div class="style2023 inbox-tabs-select-dropdown">
        <div class="input-group">
          <div class="input-group-item">
            <p-dropdown
              [options]="plannedRouteSearchTypeOptions"
              [(ngModel)]="activeRouteFilterType"
              class="input-group-filter"
            >
              <ng-template let-option pTemplate="selectedItem">
                <ng-container
                  [ngTemplateOutlet]="tabSelectOptionItem"
                  [ngTemplateOutletContext]="{
                    $implicit: option
                  }"
                ></ng-container>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <ng-container
                  [ngTemplateOutlet]="tabSelectOptionItem"
                  [ngTemplateOutletContext]="{
                    $implicit: option
                  }"
                ></ng-container>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-shrink-1">
    <button
      pButton
      class="ui-button-tertiary"
      icon="fa fa-cog"
      pTooltip="Edit Juno Settings"
      (click)="goToPreferences()"
      *ngIf="travelPreferencesEnabled && !isVME"
    ></button>
  </div>
</div>

<p-tabView
  [activeIndex]="activeRouteFilterType"
  class="hide-tab-headers route-tab-view"
  *ngIf="!isLoading"
>
  <p-tabPanel
    *ngFor="let routeFilterType of plannedRouteSearchTypeOptions; let i = index"
    [selected]="activeRouteFilterType == routeFilterType.value"
  >
    <planned-routes-tab
      [routeFilterType]="routeFilterType.value"
      (totalChange)="updatePlannedRouteCount($event, routeFilterType.value)"
      [taskScopeDays]="algoTaskScopeDays"
      [isVME]="isVME"
    ></planned-routes-tab>
  </p-tabPanel>
</p-tabView>

<p-dialog
  header="Edit Juno Settings"
  [(visible)]="showPlannedRoutePreferencesDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '810px' }"
  *ngIf="travelPreferencesEnabled && !isVME"
>
  <algo-travel-preferences
    [isInDialog]="true"
    [visible]="showPlannedRoutePreferencesDialog"
    (externalReload)="plannedRouteConfigExternalRefresh()"
  ></algo-travel-preferences>
  <p-footer>
    <div class="button-box">
      <button
        type="button"
        pButton
        label="Cancel"
        class="ui-button-tertiary"
        (click)="showPlannedRoutePreferencesDialog = false"
      ></button>
      <button
        type="submit"
        class="green-btn"
        pButton
        label="Save"
        (click)="savePreferences()"
        [disabled]="
          travelPreferencesComponent?.saving ||
          travelPreferencesComponent?.dailyChangeLimitDetails?.blockAdditionalChanges
        "
      ></button>
    </div>
  </p-footer>
</p-dialog>

<ng-template #tabSelectOptionItem let-option>
  <div class="ui-helper-clearfix flex justify-content-between">
    <div class="flex-grow-1">{{ option.label }}</div>
    <span class="ui-badge">
      <span *ngIf="loadingCounts"><i class="fa fa-spin fa-spinner"></i></span>
      <span *ngIf="!loadingCounts">{{ plannedRouteListCount(option.value) }}</span>
    </span>
  </div>
</ng-template>
